module.exports = __webpack_public_path__ + "img/base.ad5603ce.png";